import ProtectionIcon from './ProtectionIcon'

export default ProtectionIcon
